import React, { useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"

import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { loginSuperUser } from "store/actions"

import withRouter from "./../../../components/Common/withRouter"

const Login = (props) => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const [userDetails, setUserDetails] = useState({
    phone_no: "",
    password: ""
  })


  const selectLoginState = state => state.SuperUserLogin
  const LoginProperties = createSelector(selectLoginState, login => ({
    error: login.error,
  }))

  const { error } = useSelector(LoginProperties)


  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      phone_no: "" || "",
      password: "" || "",
    },
    validationSchema: Yup.object({
      phone_no: Yup.string()
        .required("Please Enter Your Phone Number")
        .matches(/^\d{10}$/, "Phone number must be 10 digits"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      dispatch(loginSuperUser(values, props.router.navigate))
    },
  })


  const handleLogin = (e) => {
    e.preventDefault();
    //     localStorage.setItem('userRole',JSON.stringify("SuperAdmin"))
    //     localStorage.setItem("authUser", JSON.stringify("eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJpZCI6NSwicGhvbmVfbm8iOiI4ODMwNjQ0MjY1IiwidXNlck1hcCI6Ind3aW5nc3Vzcl81amdzbyIsInVzZXJSb2xlX2lkIjoxLCJ1c2VyVHlwZSI6IkFkbWluIiwiaWF0IjoxNzE4MTAyMDcxLCJuYmYiOjE3MTgxMDIwNzEsImV4cCI6MTcxODEyMjA3MSwiYXVkIjoic2l0ZS11c2VycyIsImlzcyI6IlByaXNtcyJ9.IZp723ees67GlHIBWNh1QpFT9avWtt833TdYPR2PD2kNaVru8aRlJqV7TJZTPEMv"));
    //     localStorage.setItem("WWINGS_USER_TYPE", JSON.stringify("SuperAdmin"))
    // navigate('/super/admin/dashboard')

    // dispatch(loginSuperUser({phone_no: userDetails.phone_no, password: userDetails.password }))
  }
  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className="br-primary-subtle">
                <Row>
                  <Col className="col-7">
                    <div className="text-primary p-4">
                      <h3 className="text-dark">Login</h3>
                    </div>
                  </Col>
                </Row>
                {error ? <Alert color="danger" className="mx-1">{error}</Alert> : null}
              </div>
              <CardBody className="pt-0 mb-5">
                <div className="p-2">
                  <Form className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}>
                    <div className="mb-3">
                      <Label className="form-label">Phone</Label>
                      <Input
                        name="phone_no"
                        placeholder="Enter Phone number"
                        type="number"
                        onChange={e => {
                          const input = e.target.value
                          if (input.length <= 10) {
                            validation.handleChange(e)
                          }
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone_no || ""}
                        invalid={
                          validation.touched.phone_no && validation.errors.phone_no
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone_no && validation.errors.phone_no ? (
                        <FormFeedback type="invalid">
                          {validation.errors.phone_no}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Password</Label>
                      <Input
                        name="password"
                        value={validation.values.password || ""}
                        type={"password"}
                        placeholder="Enter Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                            validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                        validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mt-4 d-grid">
                      <button className="btn btn-dark btn-block" type="submit">
                        Login
                      </button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
